import { attackPatternAdapter } from './attack-pattern'

export function csvMitreAdapter(response, { type, ids }) {
  if (!response || Object.keys(response).length === 0 || !type || !ids?.length) {
    return ''
  }
  const data = attackPatternAdapter(response, { type, ids })
  let maxActorCount = 0

  const lines = Object.entries(data).flatMap(([key, values]) => {
    return values
      .map(({ identifier, name, subTechniqueList = [], associationsNames }) => {
        const { ids = '', names = '' } = subTechniqueList.reduce((acc, curr) => {
          if (curr && curr.name) {
            acc.names = acc.names ? `${acc.names}, ${curr.name}` : curr.name
          }
          if (curr && curr.attack_pattern_identifier) {
            acc.ids = acc.ids ? `${acc.ids}, ${curr.attack_pattern_identifier}` : curr.attack_pattern_identifier
          }
          return acc
        }, {})
        const actors = associationsNames.join(',')
        if (associationsNames.length > maxActorCount) {
          maxActorCount = associationsNames.length
        }
        return [key, identifier, name, `"${ids}"`, `"${names}"`, associationsNames.length, actors]
      })
  })

  const types = [
    { name: 'actor', displayName: 'Actor' },
    { name: 'campaign', displayName: 'Campaign' },
    { name: 'malware', displayName: 'Malware' }
  ]

  const typeInfo = types.find(t => t.name === type)
  const name = typeInfo.displayName
  const typeHeaders = Array.from({ length: maxActorCount }, (_, i) => `${name}${i + 1}`)

  const headers = [
    'MITRE Category Name',
    'Technique ID',
    'Technique Name',
    'Sub-Technique IDs',
    'Sub-Technique Names',
    name + '(s) usage count',
    ...typeHeaders,
  ]

  return [headers, ...lines].map(row => row.join(',')).join('\n')
}
